import { apiGet } from "../../utils/api";
import React, { useEffect, useState } from "react";

const MembersHome = () => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    async function exibir() {
      const payload = apiGet("/members");
      setMembers((await payload).data.data);
    }
    exibir();
  }, []);

  return (
    <>
      {members && members.length
        ? members.map((member) => {
            return (
              <div className="col-lg-3 pt-3 pb-3" key={member.member_id}>
                <h5>
                  {member.link_curriculum != null ? (
                    <a
                      href={member.link_curriculum}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-escuro"
                    >
                      {member.name}
                    </a>
                  ) : (
                    <>{member.name}</>
                  )}
                </h5>
                {member.institution}
              </div>
            );
          })
        : null}
    </>
  );
};

export default MembersHome;
